/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { isWindows } from "react-device-detect";
import styled from "styled-components";

import { BLOCK_TOPBAR_HEIGHT } from "src/lib/constants";

interface TopbarProps {
  isSelectable: boolean;
  isSelected?: boolean;
  tintColor?: string;
}

export const StyledBlockTopbar = styled.div<TopbarProps>`
  width: 100%;
  height: ${BLOCK_TOPBAR_HEIGHT}px;
  border-bottom: ${({ theme }) => `1px solid ${theme.block.border}`};
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  flex-shrink: 0;
  font-family: "IBM Plex Mono";
  font-size: 12px;
  background-color: ${({ isSelected, theme, tintColor }) =>
    tintColor ? tintColor : isSelected ? theme.button.hover : theme.background};
  &:active {
    background-color: ${({ theme, isSelectable }) => isSelectable && theme.button.active};
  }
`;

export const EmptySpace = styled.div<{ editable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  /* grab cursor on windows platforms is ugly, blurry */
  cursor: ${({ editable }) => editable && !isWindows && "grab"};
  &:active {
    cursor: ${({ editable }) => editable && !isWindows && "grabbing"};
  }
`;
